import { IGetVenueResponseData, IGetVenueAddress, IGetVenueCategory } from 'src/api/getVenue/types';
import { IVenue, IVenueAddress, IVenueCategory } from '../../../types/venue.types';
import createAddressSummary from '../createAddressSummary';

export const mapVenueCategory = (category: IGetVenueCategory): IVenueCategory => ({
  categoryId: category.category_id,
  name: category.name,
  parentCategoryId: category.parent_category_id,
});

export const mapVenueAddress = (address: IGetVenueAddress): IVenueAddress => {
  return {
    addressId: address.pk_address_id,
    addressLine1: address.address_line_1,
    addressLine2: address.address_line_2,
    addressLine3: address.address_line_3,
    town: address.address_town,
    postcode: address.address_post_code,
    country: {
      alpha3code: address?.country?.alpha_3_code,
      name: address?.country?.name,
    },
    type: address.address_type,
    email: address.email,
    phoneNumber: address.phone_number,
    address: createAddressSummary(address),
  };
};

export const mapVenueToDetailsPage = (venue: IGetVenueResponseData): IVenue => {
  return {
    venueId: venue.venue_id,
    name: venue.name,
    code: venue.code,
    isTrial: venue.is_trial,
    imageUrl: venue.image_url,
    creationDate: venue.creation_date,
    addresses: venue.addresses.map((address: IGetVenueAddress) => mapVenueAddress(address)),
    channels: venue.channels.map((channel) => {
      return {
        channelId: channel.channel_id,
        name: channel.name,
        externalId: channel.external_id,
        externalBrandId: channel.external_brand_id,
        pkVenueExternalIdentifierId: channel.pk_venue_external_identifier_id,
      };
    }),
    openingTimes: venue.opening_times.map((openingTime) => {
      return {
        dayOfWeek: openingTime.day_of_week,
        times: openingTime.times.map((time) => {
          return {
            startTime: time.start_time,
            endTime: time.end_time,
            openingTimeId: time.pk_venue_schedule_id,
          };
        }),
      };
    }),
    categories: venue.categories.map(mapVenueCategory),
  };
};
